import { Component, OnInit } from '@angular/core';
import { AdminService } from 'src/app/services/admin/admin.service';

@Component({
  selector: 'app-pacientes',
  templateUrl: './pacientes.component.html',
  styleUrls: ['./pacientes.component.css']
})
export class PacientesComponent implements OnInit {
  tableData: any[] = [];
  selections: any[] = [];
  removeDisabled = true;

  // Definir las columnas de la tabla
  columns = [ 'Nombre y apellido', 'Tipo doc.', 'Nro Documento', 'Reprocan', 'Estado suscripción'];

  constructor(private adminService: AdminService) {

    
  }

  ngOnInit(): void {
    this.initTable();

    

  }

  // Inicializar la tabla
  initTable(): void {

    this.adminService.obtenerTodosUsuarios().subscribe(response => {

      this.tableData = JSON.parse(response);
    }, error => { 
      console.error('Error --:>', error);
    });

    // this.tableData = [
    //   { nombre: 'Jose Dario Mosquera', tipo: 'DNI', nroDoc: '38869283', repro: false, suscripcion: false },
    //   { nombre: 'Stefania Catalina Mosquera', tipo: 'DNI', nroDoc: '24397889', repro: true, suscripcion: false },
    //   { nombre: 'Lucas Daniel Salinas', tipo: 'DNIE', nroDoc: '40299911', repro: true, suscripcion: true }
    // ];

    // this.selections = [];
  }

  // Obtener las selecciones
  getIdSelections(): number[] {
    return this.selections.map((row: any) => row.nombre);
  }

  // Manejo de la selección de filas
  onRowSelect(event: any, row: any): void {
    if (event.target.checked) {
      this.selections.push(row);
    } else {
      this.selections = this.selections.filter(item => item.id !== row.id);
    }
    this.removeDisabled = this.selections.length === 0;
  }

  // Eliminar filas seleccionadas
  removeSelected(): void {
    const ids = this.getIdSelections();
    this.tableData = this.tableData.filter(item => !ids.includes(item.nombre));
    this.removeDisabled = true;
  }

  selectAll(event) {
  }

  toggleRepro(row: any, event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    row.repro = checked;
    // Acá podés agregar lógica adicional, por ejemplo, actualizar en el servidor
  }
  
  toggleSuscripcion(row: any, event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    row.suscripcion = checked;
    // Acá podés agregar lógica adicional, por ejemplo, actualizar en el servidor
  }
  
}
